import React from "react";
import { Card } from "antd";
import DashboardLayout from "../LayoutNavbar/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../LayoutNavbar/Navbars/DashboardNavbar";
import PayBonusW2Panel from "./PayBonusW2Panel";

// Employee self-service view of pay history, bonuses and W-2 (read-only).
// All the display lives in the shared panel so the HR employee profile can
// reuse the exact same tables.
const MyPayBonus = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <Card title="My Pay & Bonuses" className="card-professional" style={{ margin: 16 }}>
      <PayBonusW2Panel />
    </Card>
  </DashboardLayout>
);

export default MyPayBonus;
